import React from 'react';
import { Crown } from 'lucide-react';
import { BookCallButton } from '../components/founding/BookCallButton';
import { FoundingHero } from '../components/founding/FoundingHero';
import { FoundingStory } from '../components/founding/FoundingStory';
import { FoundingClose } from '../components/founding/FoundingClose';
export function FoundingMembersPage() {
  return <div className="min-h-screen w-full bg-[#08070A] text-[#FDFBF7] selection:bg-[#D4AF37] selection:text-[#08070A]" data-id="element-4181" data-mp="clmyne8s68xo">
      <header className="sticky top-0 z-40 border-b border-[#D4AF37]/15 bg-[#08070A]/95 backdrop-blur" data-id="element-4182" data-mp="3g097du0yyl82">
        <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-5 py-4 sm:px-8" data-id="element-4183" data-mp="3uxt64j79vk5s">
          <div className="flex items-center gap-3" data-id="element-4184" data-mp="3pxxdfg40zf5j">
            <Crown className="h-5 w-5 text-[#D4AF37]" aria-hidden="true" data-id="element-4185" data-mp="3q09u7py1rjh0" />
            <span className="font-serif text-sm uppercase tracking-[0.28em] text-[#FDFBF7]" data-id="element-4186" data-mp="1a5hlaazbtqwz">
              Sikh Kingdoms
            </span>
          </div>
          <BookCallButton size="sm" data-id="element-4187" data-mp="29oo7nef2q4lx">
            <span className="hidden sm:inline" data-id="element-4188" data-mp="29nmmui89a3r0">Book a call</span>
            <span className="sm:hidden" data-id="element-4189" data-mp="2emzjfuoxip6s">Book</span>
          </BookCallButton>
        </div>
      </header>

      <main data-id="element-4190" data-mp="2jm2c0fnq32xv">
        <FoundingHero data-id="element-4191" data-mp="2jnnb8ikzfa22" />
        <FoundingStory data-id="element-4192" data-mp="2jn3u3435opp3" />
        <FoundingClose data-id="element-4193" data-mp="2jkrcis1b8hck" />
      </main>

      <footer className="border-t border-[#D4AF37]/15 bg-[#08070A]" data-id="element-4194" data-mp="2nogz5byfcouy">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-5 py-10 text-[10px] uppercase tracking-[0.25em] text-[#FDFBF7]/35 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-4195" data-mp="1qxwv63zshy3b">
          <p data-id="element-4196" data-mp="1zyml4r2dcu94">Life in the Sikh Kingdoms · Illuminarium Toronto · 2026</p>
          <p data-id="element-4197" data-mp="1zxbjoxwebyl6">Founding Members Programme</p>
        </div>
      </footer>
    </div>;
}